// JavaScript source code
import React, { useState,useEffect} from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getUser } from '../request';
import LoginDialog from '../components/loginDialog';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper';
import dataBanner from '../assets/fake-data/data-banner';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
SwiperCore.use([Pagination, Autoplay]);
function HomeOne(props) {
    const data = dataBanner;
    const [isShowLogin, setIsShowLogin] = useState(false);
    var user = getUser();
    const finishLogin = () => {
        setIsShowLogin(false);
        //navigate("/JoinUsStep");
        user = getUser();
    }
    useEffect(() => {
        // ��������  
        document.body.classList.add('nooverflow');

        // ���ж��ʱ�Ƴ�����  
        return () => {
            document.body.classList.remove('nooverflow');
        };
    }, []); // �����������ʾ���effectֻ��������غ�ж��ʱ����  
    return (
      
        <div className="div_bg home">
            <Header user={user} setIsShowLogin={setIsShowLogin} />
            <Footer />
            <Swiper
                modules={[Navigation]}
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 10000, disableOnInteraction: false }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                speed={1000}
                loop
            >
                {
                    data.slice(0, 3).map(item => (
                        <SwiperSlide key={item.id}>
                            <div className={item.className}>
                                <div className="container">
                                    <div className="box-slider">
                                         <div className="content-box">
                                              <p className="title" >{item.heading}</p>
                                              <p className="title1" >{item.heading1}</p>
                                              <p className="sub-title">{item.sub_heading}</p>
                                         </div>
                                    </div>
                                 </div>
                            </div>
                        </SwiperSlide>
                    ))
                }
                <div className="swiper-pagination" slot="pagination"></div>
            </Swiper>
            <LoginDialog isShowLogin={isShowLogin} onCancel={finishLogin} />

        </div>
          
    );
}

export default HomeOne;